import React, { memo } from 'react';
import { Empty } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

const EmptyData = memo(() => {
    const { t } = useTranslation();
    return (
        <div className={styles.wrapper}>
            <Empty description={`${t('ticket-detail.empty-data')}`} />
        </div>
    );
});

EmptyData.prototype = {
    emptyTitle: PropTypes.string,
};

export default EmptyData;
